module.exports = __webpack_public_path__ + "static/media/cursor-fill.171c4bb9.svg";